/**
 * TermTooltip — hover tooltip dla skrótów branżowych (2026-05-26).
 *
 * Użycie:
 *   <TermTooltip term="SWZ">SWZ</TermTooltip>
 *   <TermTooltip term="RFQ">RFQ</TermTooltip>
 *
 * Jeśli term nie istnieje w glossary, renderuje children bez tooltipu (graceful).
 *
 * Powstałe w odpowiedzi na zgłoszenie Izabeli 0475d485 — "tajemnicze skróty
 * działań". Hover ujawnia pełną nazwę + krótki opis kontekstowy.
 */

import React from 'react';
import { lookupTerm } from '../../lib/glossary';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '../ui/tooltip';
import { Info } from 'lucide-react';

export default function TermTooltip({ term, children, showIcon = false, className = '' }) {
  const def = lookupTerm(term);

  // Brak definicji — render children bez tooltipu (graceful)
  if (!def) return <>{children}</>;

  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={`underline decoration-dotted decoration-muted-foreground/60 cursor-help inline-flex items-center gap-0.5 ${className}`}
          >
            {children}
            {showIcon && <Info className="w-3 h-3 text-muted-foreground/70" />}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-sm text-xs" side="top">
          <div className="font-semibold mb-1">{def.full}</div>
          <div className="text-muted-foreground leading-relaxed whitespace-pre-line">{def.desc}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
